import React from "react";
import { withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { activate } from "../../services/billingService";
import { getVoucherDurationText, getVoucherDurationTextForArabic } from "../../services/copyService";
import { getAppState } from "../../state/index";
import { trackPage, trackEvent, getRedemptionSuccessTrackingData } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import { Text, withFocusable, Loading } from "../../services/visualLibraryService";
import { getSdk } from "../../services/sdkService";
import { eVoucherProvisioning } from "../../services/eVoucherEligibilityService";
import {
  PromotionalPageStyled,
  PromotionalContainerStyled,
  HeadingStyled,
  ButtonModalStyled,
  TextStyled,
  TextDisclaimerStyled,
  LogoContainerStyled,
  LogoWrapper
} from "./styles/Styled";
import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import Logo, { LGLogo } from "../../components/Logo";
import { LogoWrapperStyled } from "../../components/Header/styles/Styled";
import { isAnyAddonStatusActive } from "../../utils/subscriptionUtils";
import {getSubscriptionDisplayName} from "../../utils/promotionUtils";

const PAGE = "promotions";
const SIGNUP = "signup";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";

const startFocusPath = "startVoucherModal_passThru";
const closeFocusPath = "closeVoucherModal_passThru";

const proceedToHomePath = "proceedToHomeButtonModalFocusPath";

function getGenericProvisioningError() {
  let heading = "Oops!";
  let text = `pages.voucherRedemption.errors.generic`;
  return {
    dismissable: false,
    modalTitle: heading,
    modalText: i18n.get(text),
    buttons: [
      {
        label: i18n.get("pages.voucherRedemption.proceedHomePage"),
        displayBlock: true,
        focusPath: proceedToHomePath,
        buttonHandler: () => {
          this.closeModal(false);
          redirectTo.call(this, routes.profileSelector, historyMethods.REPLACE);
        }
      },
      {
        label: i18n.get("pages.voucherRedemption.exitButton"),
        displayBlock: true,
        focusPath: "exitButtonModalFocusPath",
        buttonHandler: async () => {
          await getSdk();
          getSdk().systemManager.application.exit();
        }
      }
    ]
  };
}

function handleRequestError(error) {
  const { stateActions } = this.props;
  trackEvent(SIGNUP, "evoucher_redemption_error", error.message);
  stateActions.showSettingsModal(getGenericProvisioningError.call(this));
  this.props.setFocus(proceedToHomePath);
}

class promotionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedeeming: false,
      isLoading: false,
      voucherSubscriptionName: null
    };

    this.enterHandler = this.enterHandler.bind(this);
    this.getActiveUserCloseHandler = this.getActiveUserCloseHandler.bind(this);
    this.redeemVoucher = this.redeemVoucher.bind(this);
    const {
      applicationState: { userLogged }
    } = props;
    this.props.setFocus(`${userLogged ? startFocusPath : joinFocusPath}`);
  }

  async componentDidMount() {
    const { onRef } = this.props;
    const {voucherData } = getAppState();
    trackPage(PAGE);
    onRef && onRef(this);
    this.setState({ voucherSubscriptionName: await getSubscriptionDisplayName(!!voucherData && voucherData.vouchers[0].subscriptions.join(",")) }); 

  }
  getActiveUserCloseHandler() {
    const {
      applicationState: { userAccountStatus }
    } = this.props;
    isUserAccountActive(userAccountStatus) && localStorage && localStorage.setItem("showVoucherPopup", false);
    this.enterHandler("landing_user_selects_later", routes.profileSelector);
  }

  clearVoucherData() {
    getAppState().voucherData = null;
  }

  async enterHandler(eventAction, path, locationData) {
    this.setState({ isLoading: true });
    if (eventAction === "landing_user_selects_startnow") {
      const path = await checkForUmanagedOrNonChangeableMop.call(this);
      if (path === routes.nonchangeable) {
        redirectTo.call(this, routes.nonchangeable, historyMethods.REPLACE);
      } else {
        this.redeemVoucher();
      }
      return;
    }
    eventAction !== "landing_user_selects_startnow" && trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  closeModal(redirectToLanding = false) {
    const {
      stateActions: { hideSettingsModal }
    } = this.props;
    hideSettingsModal();
    if (redirectToLanding) {
      redirectTo.call(this, routes.home, historyMethods.REPLACE);
    }
  }

  async redeemVoucher() {
    const { voucherData } = getAppState();
    const {
      history: { location },
      setFocus
    } = this.props;
    try {
      this.setState({ isRedeeming: true });
      let baseCode = voucherData && voucherData.vouchers[0].code;
      let addonCode = undefined;
      this.setState({ isLoading: true });
      if (voucherData) {
        if (voucherData.status === "INVALID") {
          throw voucherData;
        }
        const vouchers = voucherData.vouchers.reduce((acc, val) => {
          if (val.subscriptions.includes("starzplay")) {
            acc.baseCode = val.code;
          } else {
            acc.addonCode = val.code;
          }
          return acc;
        }, {});

        baseCode = vouchers.baseCode;
        addonCode = vouchers.addonCode;
      }

      await eVoucherProvisioning(baseCode, addonCode);

      const userInfo = await getSdk().userManager.get({ avoidCache: true });
      trackEvent(SIGNUP, "evoucher_redemption_success", getRedemptionSuccessTrackingData.call(this));
      this.setState({ isRedeeming: false });
      getAppState().currentProfileType = userInfo?.profileType;
      localStorage.removeItem("voucherData");
      getAppState().userAccountStatus = userInfo.settings.accountStatus;
      getAppState().userAddonStatus = isAnyAddonStatusActive(userInfo?.settings?.addons);
      getAppState().addons = userInfo.settings.addons;
      getAppState().isActiveUser = userInfo.settings.accountStatus;
      //getAppState().voucherData = null;

      redirectTo.call(
        this,
        routes.thankyou,
        location && location.state && location.state.fromSignup && { fromSignup: location.state.fromSignup },
        historyMethods.REPLACE
      );
    } catch (e) {
      this.setState({ isLoading: false });
      this.setState({ isRedeeming: false });
      handleRequestError.call(this, e);
      //setFocus(getGlobalButtonFocusPath("back"));
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { userLogged, voucherData } = getAppState();
    const {
      applicationState: { userLocale }
    } = this.props;
    const voucherDuration = !!voucherData && getVoucherDurationText(voucherData.vouchers[0].duration);
    const voucherType = !!voucherData && voucherData.vouchers[0].subscriptions.join(",");
    const subscriptionPlaceHolderTransl = (voucherType && voucherType  === 'starzplayultimate') 
                                          ? i18n.get("pages.promotions.subStatementGeneralPlaceholderUltimate") 
                                          : (voucherType && voucherType  === 'starzplaysports') 
                                          ? i18n.get("pages.promotions.subStatementGeneralPlaceholderSports") 
                                          : i18n.get("pages.promotions.subStatementGeneralPlaceholder")

    const textForArabic = i18n.getDirection() === "rtl" ? getVoucherDurationTextForArabic(voucherDuration) : "";
    const backgroundUrl =
      i18n.getDirection() === "ltr"
        ? "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/lg/lg-promotion/background-ltr.png"
        : "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/lg/lg-promotion/background-rtl.png";

    return (
      <PromotionalPageStyled background={backgroundUrl}>
        {this.state.isLoading && <Loading overlay />}
        <PromotionalContainerStyled>
          <LogoWrapper>
            <LGLogo />
            <LogoContainerStyled>
              <Logo />
            </LogoContainerStyled>
          </LogoWrapper>
          <HeadingStyled rank="1" text={i18n.get("pages.promotions.mainStatement")} size="medium" />

          <TextStyled inlineBlock text={i18n.get("pages.promotions.subStatementGeneral", subscriptionPlaceHolderTransl)} size="medium" />
          {i18n.getDirection() === "ltr" ? (
            <TextStyled
              text={
                parseInt(voucherDuration) === 1
                  ? i18n.get(
                      "pages.promotions.subStatment1month",
                      voucherDuration,
                      this.state.voucherSubscriptionName && this.state.voucherSubscriptionName.toUpperCase()
                    )
                  : i18n.get(
                      "pages.promotions.subStatementGeneral2",
                      voucherDuration,
                      this.state.voucherSubscriptionName && this.state.voucherSubscriptionName.toUpperCase()
                    )
              }
              size="medium"
            />
          ) : parseInt(voucherDuration) > 2 ? (
            <TextStyled
              text={i18n.get(
                `pages.promotions.${textForArabic}`,
                voucherDuration,
                this.state.voucherSubscriptionName && this.state.voucherSubscriptionName.toUpperCase()
              )}
              size="medium"
            />
          ) : (
            <TextStyled
              text={i18n.get(`pages.promotions.${textForArabic}`, this.state.voucherSubscriptionName && this.state.voucherSubscriptionName.toUpperCase())}
              size="medium"
            />
          )}
          {!userLogged ? (
            <>
              <TextStyled text={i18n.get("pages.promotions.subStatementIfNotLogged")} size="medium" />

              <ButtonModalFocus
                label={i18n.get("pages.promotions.signup")}
                focusPath={loginFocusPath}
                onEnterPress={() =>
                  this.enterHandler("landing_user_selects_login", routes.pinSignup, {
                    backDestination: routes.home,
                    nextPage: routes.signup
                  })
                }
                onMouseUp={() =>
                  this.enterHandler("landing_user_selects_login", routes.pinSignup, {
                    backDestination: routes.home,
                    nextPage: routes.signup
                  })
                }
                size="small"
                dataSnUp={""}
                dataSnDown={`@${joinFocusPath}`}
              />
              <ButtonModalFocus
                label={i18n.get("pages.promotions.login")}
                focusPath={joinFocusPath}
                onEnterPress={() =>
                  this.enterHandler("landing_user_selects_login", routes.pin, {
                    backDestination: routes.home
                    //nextPage: routes.redeem
                  })
                }
                onMouseUp={() =>
                  this.enterHandler("landing_user_selects_login", routes.pin, {
                    backDestination: routes.home
                    //nextPage: routes.redeem
                  })
                }
                size="small"
                dataSnUp={`@${loginFocusPath}`}
                dataSnDown={""}
              />
            </>
          ) : (
            <>
              <TextStyled text={i18n.get("pages.promotions.doYouWantToRadeem")} size="medium" />

              <ButtonModalFocus
                label={` ${
                  userLocale === "fr" && parseInt(voucherDuration) === 1
                    ? i18n.get("pages.promotions.radeemNowButton1Month")
                    : i18n.get("pages.promotions.radeemNowButton")
                }`}
                focusPath={startFocusPath}
                onEnterPress={() => this.enterHandler("landing_user_selects_startnow", routes.profileSelector)}
                onMouseUp={() => this.enterHandler("landing_user_selects_startnow", routes.profileSelector)}
                size="small"
                dataSnUp={""}
                dataSnDown={`@${closeFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <ButtonModalFocus
                label={i18n.get("pages.promotions.notNowButton")}
                focusPath={closeFocusPath}
                onEnterPress={this.getActiveUserCloseHandler}
                onMouseUp={this.getActiveUserCloseHandler}
                displayBlock
                size="small"
                dataSnUp={`@${startFocusPath}`}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
              />
            </>
          )}

          <TextDisclaimerStyled text={i18n.get("pages.promotions.footerDesclamier2")} size="xsmall" />
        </PromotionalContainerStyled>
      </PromotionalPageStyled>
    );
  }
}

export default withAppState(promotionsPage);
